import React, { useEffect, useState, useRef } from 'react'

import M2niCascadedList from '../../components/selectionFolder/m2ni_cascaded_list/index'
import FileItemEdit from '../../components/selectionFolder/fileItem/fileItemEdit/index'
import style from './index.module.scss'
import GanttSchedule from '../../components/ganttSchedule/index'
import * as apis from '../../api/networkDisk'
import moment from 'moment'
import useStore from '../../store/useStore'
// import originalSetItem from '../../modules/storage'
import { Tooltip, Modal, message, Table, DatePicker } from 'antd'
import type { ColumnsType } from 'antd/es/table';
import { getUserList } from '../../api/user'
import { createVoidZero } from 'typescript'
const { confirm } = Modal;
const { RangePicker } = DatePicker;


interface Props {
  history: any;
}
interface DataType {
  key: React.Key;
  name: string;
}
let params: any = {}

const Gantt = (props: Props) => {
  const [ganttVisible, setGanttVisible] = useState<boolean>(false);
  const [taskData, setTaskData] = useState<any>([]);
  const { store, dispatch } = useStore();
  const [searchDate, setSearchDate] = useState<any>([]);


  let ganttDate: any = []
  let okButtonShow: any = true
  useEffect(() => {
    // onGetUserList()
    memoTask()

  }, [])
  useEffect(() => {
    if (!store.ganttDate || !store.ganttUser) {
      // reset()
    }

  }, [store.ganttDate, store.ganttUser])
  useEffect(() => {
    setGanttVisible(false)
    memoTask()
  }, [store.ganttExecutorRows])
  /**
 * @name 重置
 */
  const reset = () => {
    setSearchDate(null)
  }
  const setModalVisible = (name: any, val: any) => {
    dispatch({
      type: name,
      data: val
    });
  }
  const memoTask = async () => {
    try {
      setTaskData([])
      if (searchDate && searchDate.length > 1) {
        params.startDate = moment(searchDate[0]).format('YYYY-MM-DDT[00]:[00]:[00]')
        params.endDate = moment(searchDate[1]).format('YYYY-MM-DDT[23]:[59]:[59]')
      } else {
        params.startDate = moment(new Date()).format('YYYY-MM-DDT[00]:[00]:[00]')
        params.endDate = moment(new Date()).add(1, "months").format('YYYY-MM-DDT[23]:[59]:[59]')
      }
      if (store.ganttExecutoRowKeys && store.ganttExecutoRowKeys.length > 0) {
        params.executorIds = store.ganttExecutoRowKeys
        //selectedRows做交互用，不作为参数
      }

      let res: any = await apis.memoLask(params)
      if (res.ok) {
        console.log(res.data)
        setTaskData(res.data)
        setTimeout(() => {
          setGanttVisible(true)
        }, 200)
      }
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div style={{ height: '100vh', width: '100vw' }}>

      {ganttVisible &&
        <GanttSchedule data={taskData} />
      }

      <Modal open={
        store.ganttDate
      }
        okText={'确认'}
        cancelText={'取消'}
        onCancel={() => {
          setModalVisible('SET_GANTTDATE', false)


        }}
        title='选择起止时间'
        onOk={() => {
          setGanttVisible(false)
          memoTask()
          setModalVisible('SET_GANTTDATE', false)
        }
        }
      >
        <div>
          起止时间
          <RangePicker value={searchDate} onChange={(e: any) => {
            console.log(e)
            setSearchDate(e)
            // okButtonShow = false
          }} />
        </div>
      </Modal>
    </div>
  )
}

export default Gantt
